import React from 'react';
import { useAtom } from 'jotai';
import { FormattedMessage } from 'react-intl';
import { Button } from '@statsbomb/kitbag-components';
import { alphaToggleAtom } from '../../atoms/alpha';

export function Toggles() {
  const [isAlphaEnabled, toggleAlphaEnabled] = useAtom(alphaToggleAtom);

  return (
    <Button onClick={() => toggleAlphaEnabled()}>
      {isAlphaEnabled ? (
        <FormattedMessage
          defaultMessage="Disable Alpha Test Features"
          id="f692e"
        />
      ) : (
        <FormattedMessage
          defaultMessage="Enable Alpha Test Features"
          id="93136"
        />
      )}
    </Button>
  );
}

export default { Toggles };
